/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Card_DurationInputs */

const en_us2_workout_share_card_duration = /** @type {(inputs: Workout_Share_Card_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const pt_br2_workout_share_card_duration = /** @type {(inputs: Workout_Share_Card_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

const es_419_workout_share_card_duration = /** @type {(inputs: Workout_Share_Card_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const pt_pt2_workout_share_card_duration = /** @type {(inputs: Workout_Share_Card_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

const fr_fr2_workout_share_card_duration = /** @type {(inputs: Workout_Share_Card_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

const de_de2_workout_share_card_duration = /** @type {(inputs: Workout_Share_Card_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const it_it2_workout_share_card_duration = /** @type {(inputs: Workout_Share_Card_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Workout_Share_Card_DurationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_card_duration = /** @type {((inputs?: Workout_Share_Card_DurationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Card_DurationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_card_duration(inputs)
	if (locale === "es-419") return es_419_workout_share_card_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_card_duration(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_card_duration(inputs)
	if (locale === "de-DE") return de_de2_workout_share_card_duration(inputs)
	if (locale === "it-IT") return it_it2_workout_share_card_duration(inputs)
	return en_us2_workout_share_card_duration(inputs)
});
export { workout_share_card_duration as "workout-share.card_duration" }